import React, { useContext, useEffect } from 'react';
import SCHEDULE_ORDER_SAMPLE_DATA from '../Data/SampleData';
import ScheduleOrderForm from '../Presentation/ScheduleOrderForm';
import ScheduleOrderInsideModal from '../Presentation/ScheduleOrderInsideModal';
import { UserOrderContext } from '../../../context/context';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

export const ScheduleOrder = props => {
  const { onStoreSelectFinish } = props;
  // get the context from parent
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { contentData } = SCHEDULE_ORDER_SAMPLE_DATA;
  const { scheduleOrderHeaderText, scheduleOrderModalContent, changeScheduleOrderHeaderText } = contentData;
  const { formContent } = scheduleOrderModalContent;
  const { SEARCH_ORDER_DATA, SCHEDULE_ORDER_DATA } = START_ORDER_CONSTANTS;
  const { scheduleOrderData } = userOrderState;
  const { changeFlow = false } = scheduleOrderData;
  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    localStorage.setItem('renderComp', true);
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        selectedStoreInfo: userOrderState.scheduleOrderData.storeInfo,
        showScheduleOrderCatering: false,
      },
    });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
  };

  useEffect(() => {
    const closeScheduleOrderModal = eventOfScheduleOrderModal => {
      if (eventOfScheduleOrderModal.keyCode === 27) {
        handleClose(eventOfScheduleOrderModal);
      }
    };
    window.addEventListener('keydown', closeScheduleOrderModal);
    return () => window.removeEventListener('keydown', closeScheduleOrderModal);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoBack = () => {
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: true },
    });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        showScheduleOrderCatering: false,
      },
    });
  };

  const scheduleOrderForm = <ScheduleOrderForm formContent={formContent} onStoreSelectFinish={onStoreSelectFinish} />;
  return(
    <ScheduleOrderInsideModal
      handleGoBack={handleGoBack}
      handleClose={handleClose}
      ScheduleOrderForm={scheduleOrderForm}
      modalTitleId='schedule-order'
      headerText={
        changeFlow ? translateWithI18Next(changeScheduleOrderHeaderText) : translateWithI18Next(scheduleOrderHeaderText)
      }
    />
  );
};

export default ScheduleOrder;
